import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../fonts/breuer-headline.css";
import "./rules.css";
import { setBackButtonUrl } from "../uiSlice";
import startBtnImg from "../images/next.png";
import paperBg from "../images/paper.png";
import titleBg from "../images/title.png";

const STATIC_RULES = [
  "Your Hogwarts Trials begin… let's see what kind of wizard you are",
  "A flick of your wand and magic follows… aim well, not everything deserves a spell",
  "The pace quickens… your control will decide everything now",
  "The skies open up… your broom is ready",
  "Glide through the hoops and feel yourself closing in",
  "The Golden Snitch teases from ahead… it never comes easy",
  "Stay sharp, stay steady… greatness is within reach",
];

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, user } = useSelector((state) => state.auth);

  useEffect(() => {
    document.documentElement.classList.add("rules-static-bg");
    document.body.classList.add("rules-static-bg");
    return () => {
      document.documentElement.classList.remove("rules-static-bg");
      document.body.classList.remove("rules-static-bg");
    };
  }, []);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [dispatch, status, user]);

  const handleStartClick = () => {
    navigate("/sorthat");
  };

  return (
    <div className="user-rules-page">
      <div className="user-rules-stack">
      <legend
            className="user-rules-heading"
            style={{ backgroundImage: `url(${titleBg})` }}
          >
            How to Play
          </legend>
        <fieldset
          className="user-rules-fieldset"
          style={{ backgroundImage: `url(${paperBg})` }}
        >
         
          <ul className="user-rules-list">
            {STATIC_RULES.map((text, index) => (
              <li key={index}>{text}</li>
            ))}
          </ul>
        </fieldset>
        <button
          type="button"
          className="user-rules-start-btn"
          onClick={handleStartClick}
        >
          <img src={startBtnImg} alt="Start game" />
        </button>
      </div>
    </div>
  );
}

export default UserRules;
